import { Component, effect, input, InputSignal } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class  FileUploaderComponent {
  files: InputSignal<File[]> = input<File[]>();

  multiple: InputSignal<boolean> = input<boolean>(true);
  accept: InputSignal<string[]> = input<string[]>([]);
  formControlRef: InputSignal<FormControl<File[]>> = input<FormControl<File[]>>(
    new FormControl()
  );

  localFiles: File[] = [];

  constructor() {
    effect(() => {
      this.localFiles = this.files();
    });
  }

  onFileSelected(event): void {
    this.localFiles = Array.from(event);
    this.formControlRef().setValue(this.localFiles);
  }

  removeItem(event): void {
    const index = this.localFiles.indexOf(event);
    this.localFiles.splice(index, 1);
  }

   reset(): void {
    this.localFiles = [];
    this.formControlRef().reset();
  }
}
